import { all, call, delay, put, takeLatest } from 'redux-saga/effects';
import { loadUsage } from 'store/modules/settings/actions';
import { LOAD_ACCOUNT } from 'store/modules/settings/types';

function* fetchUsage({ payload }) {
  yield put(loadUsage(payload?.accountId));
}

export default function* root() {
  yield all([takeLatest(LOAD_ACCOUNT, fetchUsage)]);
}
